import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login/Login';
import AdminDashboard from './pages/Admin/AdminDashboard';
import StudentDashboard from './pages/Student/StudentDashboard';
import './index.css';

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    
                    <Route 
                        path="/admin/*" 
                        element={
                            <PrivateRoute requireAdmin={true}>
                                <AdminDashboard />
                            </PrivateRoute>
                        } 
                    />
                    
                    <Route 
                        path="/student/*" 
                        element={
                            <PrivateRoute>
                                <StudentDashboard />
                            </PrivateRoute>
                        } 
                    />
                    
                    <Route path="/" element={<Navigate to="/login" replace />} />
                    <Route path="*" element={<Navigate to="/login" replace />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;
